module.exports = __webpack_public_path__ + "static/media/thanksVoice.09c0db8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system/music/thanksVoice.mp3
// module id = k1Pq
// module chunks = 55